import * as React from 'react';
import MyPagePanel from '.';
import { connect } from 'react-redux';
import { UserSelector } from 'src/Entities/User/User.Selector';
import { IComingCourses } from 'src/Entities/User/User';
import { IActivityModel } from 'src/Entities/Activity/Activity';
import { Action, Dispatch } from 'redux';
import { toggelShowUserInterest } from 'src/Entities/User/User.Actions';

type Props = {
  onlyShowRelevant: boolean;
  upcoming: IComingCourses[];
  favorites: IActivityModel[];
  toggleOnlyShowRelevant: (value: boolean) => void;
};

const MyPagePanelContainer = ({
  onlyShowRelevant,
  upcoming,
  favorites,
  toggleOnlyShowRelevant,
}: Props) => {
  const [isExpanded, setIsExpanded] = React.useState(false);

  return (
    <MyPagePanel
      isExpanded={isExpanded}
      onlyShowRelevant={onlyShowRelevant}
      upcoming={upcoming || []}
      favorites={favorites || []}
      onExpandClick={() => setIsExpanded(!isExpanded)}
      onOnlyShowRelevantChange={toggleOnlyShowRelevant}
    />
  );
};

const mapStateToProps = () => ({
  onlyShowRelevant: UserSelector.isShowOnlyUserIntrests(),
  upcoming: UserSelector.getUserComingCourses(),
  favorites: UserSelector.getUserFavoriteActivities(),
});

const mapDispatchToProps = (dispatch: Dispatch<Action<any>>) => ({
  toggleOnlyShowRelevant: (value: boolean) => dispatch(toggelShowUserInterest(value)),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(MyPagePanelContainer);



// WEBPACK FOOTER //
// ./src/components/MyPagePanel/Container.tsx